/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate } from "@fortawesome/free-solid-svg-icons";
import WorkflowsIcon from "../../../assets/icons/workflows.svg2";
import HelpButton from "../../HelpContent/HelpButton";
import NewFeature from "../../Builder/Components/NewFeature";

export default function WorkflowsWidget({ processGUID, projectUUID }) {
  const [period, setPeriod] = useState("");
  const [workflowsData, setWorkflowsData] = useState({
    Resolved: "88.6",
    Unresolved: "11.4",
    UnresolvedActive: "54",
    UnresolvedExpired: "46",
    AvgWorkflowRuntime: {
      mins: "1",
      secs: "04",
    },
    SurveysCompleted: "77",
    InteractionsUsed: "566",
  });
  const [loading, setLoading] = useState(false);

  // const getStats = async () => {
  //   setLoading(true);
  //   const data = await proxyAPI({
  //     prefix: "logic/workflows/api",
  //     url: `process-stats?${period !== "" ? `started=${period}` : ""}${
  //       projectUUID ? `&project=${projectUUID}` : ""
  //     }${processGUID ? `&process=${processGUID}` : ""}`,
  //   });
  // };

  const datePeriod = () => {
    if (period === "") {
      return <span className="fw-bold small me-2">All Processes</span>;
    }

    if (period === "today") {
      return (
        <>
          <span className="fw-bold small me-2">Processes started</span>
          <span className="small opacity-50 text-nowrap">
            {new Date().toLocaleDateString()}
          </span>
        </>
      );
    }

    if (period === "week") {
      const curr = new Date();
      return (
        <>
          <span className="fw-bold small me-2">Processes started</span>
          <span className="small opacity-50 text-nowrap">
            {new Date(
              curr.setDate(curr.getDate() - curr.getDay() + 1)
            ).toLocaleDateString()}{" "}
            - {new Date().toLocaleDateString()}
          </span>
        </>
      );
    }

    if (period === "month") {
      const curr = new Date();
      return (
        <>
          <span className="fw-bold small me-2">Processes started</span>
          <span className="small opacity-50 text-nowrap">
            {new Date(curr.setDate(1)).toLocaleDateString()} -{" "}
            {new Date().toLocaleDateString()}
          </span>
        </>
      );
    }
  };

  return (
    <div className="position-relative px-2 d-flex flex-column h-100">
      {loading && (
        <div className="position-absolute top-0 start-0 h-100 w-100 text-bg-light bg-opacity-50 z-1">
          <div className="position-absolute top-50 start-50 translate-middle text-white">
            <FontAwesomeIcon icon={faRotate} spin size="5x" />
          </div>
        </div>
      )}
      <div className="d-flex p-3 align-items-center widget-header">
        <WorkflowsIcon width={20} className="white opacity-50" />
        <h6 className="m-0 mx-2 small fw-bold">WORKFLOWS</h6>
        <HelpButton helpKey="widget-workflows" iconClassName="white" />
      </div>
      <NewFeature>
        <div className="mt-2">
          {[
            {
              label: <div className="opacity-50">% Resolved</div>,
              value: `${workflowsData.Resolved}%`,
            },
            {
              label: (
                <div>
                  <div className="opacity-50">% Unresolved</div>
                  <div className="fs-2 opacity-100">
                    {workflowsData.Unresolved}%
                  </div>
                </div>
              ),
              value: (
                <div className="d-flex  ">
                  <div className="fs-2 p-2 border-end border-secondary border-opacity-50">
                    {workflowsData.UnresolvedActive}%
                    <div className="fs-6 text-light-green">Active</div>
                  </div>

                  <div className="fs-2 p-2">
                    {workflowsData.UnresolvedExpired}%{" "}
                    <div className="fs-6 text-red">Expired</div>
                  </div>
                </div>
              ),
            },
            {
              label: <div className="opacity-50">Avg workflow runtime</div>,
              value: (
                <div>
                  <span className="fs-2">
                    {workflowsData.AvgWorkflowRuntime.mins}
                  </span>
                  <span className="opacity-50 fs-5">mins</span>
                  <span className="fs-2">
                    {" "}
                    {workflowsData.AvgWorkflowRuntime.secs}
                  </span>
                  <span className="opacity-50 fs-5">secs</span>
                </div>
              ),
            },
            {
              label: <div className="opacity-50"> % Surveys completed</div>,
              value: `${workflowsData.SurveysCompleted}%`,
            },
            {
              label: <div className="opacity-50">Interactions used</div>,
              value: <div>{workflowsData.InteractionsUsed}</div>,
            },
          ].map((r, i) => (
            <React.Fragment key={i}>
              <hr className="m-1" />
              <div className="d-flex justify-content-between px-3">
                <span className="fw-bold p-1">{r.label}</span>
                <h3 className="fw-bold m-0 p-1">{r.value}</h3>
              </div>
            </React.Fragment>
          ))}
        </div>
        <div className="flex-grow-1" />

        <div className="px-3">
          <hr />
          <button
            type="button"
            className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
              period === "" ? "" : "opacity-50"
            }`}
            onClick={() => setPeriod("")}
          >
            ALL
          </button>
          <button
            type="button"
            className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
              period === "today" ? "" : "opacity-50"
            }`}
            onClick={() => setPeriod("today")}
          >
            DAY
          </button>
          <button
            type="button"
            className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
              period === "week" ? "" : "opacity-50"
            }`}
            onClick={() => setPeriod("week")}
          >
            WEEK
          </button>
          <button
            type="button"
            className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
              period === "month" ? "" : "opacity-50"
            }`}
            onClick={() => setPeriod("month")}
          >
            MONTH
          </button>
        </div>
        <div className="p-2">{datePeriod()}</div>
      </NewFeature>
    </div>
  );
}
